import { render, staticRenderFns } from "./accept-table.vue?vue&type=template&id=60de5e14&scoped=true&"
import script from "./accept-table.vue?vue&type=script&lang=ts&"
export * from "./accept-table.vue?vue&type=script&lang=ts&"
import style0 from "./accept-table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./accept-table.vue?vue&type=style&index=1&id=60de5e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de5e14",
  null
  
)

export default component.exports